module.exports = __webpack_public_path__ + "img/chevron-down.7dc1ac03.svg";